import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Panel, PanelHeader, PanelBody } from '../../../../components/panel/panel';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import * as formik from 'formik';
import * as yup from 'yup';
import Swal from 'sweetalert2';
import axiosClient from '../../../../config/axios.js';
import RoleFields from './roleFields';

function NewRole() {
    const navigate = useNavigate();
    const { Formik } = formik;


    return (
        <div>
            <div className="d-flex align-items-center mb-3">
                <div>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><Link to="/">Inicio</Link></li>
                        <li className="breadcrumb-item">Configuración</li>
                        <li className="breadcrumb-item"><Link to="/settings/roles">Roles</Link></li>
                        <li className="breadcrumb-item active">Nuevo Rol</li>
                    </ol>
                    <h1 className="page-header mb-0">Registro de nuevo Rol</h1>
                </div>
            </div>



            <div className="row mb-3">
                <div className="col-xl-12">
                    <Panel>
                        <PanelHeader>Registro de nuevo Rol</PanelHeader>
                        <PanelBody>
                            <Formik
                                validationSchema={yup.object().shape({
                                    role_name: yup.string().required("Ingrese el nombre del Rol"),
                                    categoryPermissions: yup.array().of(
                                        yup.object().shape({
                                            active: yup.boolean()
                                        })
                                    ),
                                })}
                                onSubmit={(values, { setSubmitting }) => {
                                    setSubmitting(false);
                                    axiosClient.post('/roles/save', values).then(response => {
                                        
                                        Swal.fire({
                                            title: 'Registro exitoso.',
                                            text: 'Se ha registrado el nuevo Rol',
                                            icon: 'success',
                                            confirmButtonText: 'Cerrar',
                                            cancelButtonText: 'Cancelar',
                                            showCancelButton: false,
                                        });
                                        navigate('/settings/roles');
                                    }).catch(err => {
                                        
                                        let message = '';
                                        if (err.response.data.original.code === '23505') {
                                            message = 'El nombre de rol ya existe. Ingresa uno diferente.';
                                        } else {
                                            message = err.response.data.message;
                                        }
                                        Swal.fire({
                                            title: 'Ups!',
                                            text: message,
                                            icon: 'error',
                                            confirmButtonText: 'Cerrar',
                                            cancelButtonText: 'Cancelar',
                                            showCancelButton: false,
                                        });
                                    });
                                }}
                                initialValues={{
                                    role_name: '',
                                    categoryPermissions: [],
                                    editable_role_name: true
                                }}
                            >
                                {({ handleSubmit, handleChange, handleBlur, values, touched, errors, setFieldValue, setFieldTouched }) => (
                                    <Form noValidate enableReinitialize onSubmit={handleSubmit}>
                                        <RoleFields
                                            values={values}
                                            handleChange={handleChange}
                                            handleBlur={handleBlur}
                                            setFieldValue={setFieldValue}
                                            setFieldTouched={setFieldTouched}
                                            touched={touched}
                                            errors={errors}
                                        />

                                        <Row className="mb-3">
                                            <Col md="12">
                                                <Button type="submit">Guardar rol</Button>{' '}
                                                <Link to={'/settings/roles'} className="btn btn-info">Cancelar</Link>
                                            </Col>
                                        </Row>
                                    </Form>
                                )}
                            </Formik>

                        </PanelBody>
                    </Panel>
                </div>

            </div>


        </div>

    );
}

export default NewRole;